import { VF_LOOKUP_TABLE } from 'AppSrc/core/components/forms/form-base-components/v-f-lookup-table';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  INCIDENT_REFERENCE,
} from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/relationship-constants';
import { searchIncidents } from 'AppSrc/core/relationships/relationships-queries';
import {
  MOBILE,
  RT_INCIDENT,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const fieldId = INCIDENT_REFERENCE;

const initialValues = '';

const resultsColumns = [
  { id: 'incident', label: 'Incident reference' },
  { id: 'description', label: 'Description' },
  { id: 'company', label: 'Company' },
  { id: 'status', label: 'CI Status' },
];

// return a relationship object for the incident search result
const getRelationshipForIncident = (incident) => {
  if (!incident) { return null; }
  const {
    id,
    status,
  } = incident;
  return ({
    name: id, // for an incident, the incident id is what displays as the name
    referenceId: id,
    referenceType: RT_INCIDENT,
    status,
  });
};

const getSearchResultForIncident = (incident) => ({
  id: incident.id,
  columnValues: {
    incident: incident.id,
    company: incident.organisation,
    description: incident.description,
    status: incident.status,
  },
  value: getRelationshipForIncident(incident),
});

const getSelectedIdForValue = (value) => value && value.referenceId;

const performSearch = (searchQuery) => searchIncidents(MOBILE, searchQuery)
  .then((incidents) => incidents.map(getSearchResultForIncident));

const vFParams = {
  fieldTitle: 'Incident reference',
  placeholder: 'Search incident reference',
  performSearch,
  resultsColumns,
  getSelectedIdForValue,
  // initial search should also be id
  getInitialSearchQueryForValue: getSelectedIdForValue,
};

const validator = (params) => {
  const {
    values,
  } = params;
  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_LOOKUP_TABLE);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push(noValue ? 'Please enter incident reference' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const incidentReference = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_LOOKUP_TABLE,
};

export { incidentReference };
